import ChevronDownIcon from "@assets/icons/chevron-down.svg";

import { AINote } from "@app-types/notes.type";
import { Note } from "@components/Sections/NoteSection/Note";
import { SectionHeading } from "@ui/Headings";
import { Counter } from "@ui/Counter";
import { Button } from "@ui/Button";

interface Props {
  notes: AINote[];
  onGoBack: () => void;
}

export default function NotesScreen({ notes, onGoBack }: Props) {
  return (
    <div className="flex flex-col justify-center items-center px-4 py-[8px_30px]">
      <header className="w-full flex items-center gap-1 mt-2">
        <Button
          className="h-8 w-8 p-0 dark:hover:bg-gray-700"
          buttonType={"TRANSPARENT"}
          onClick={onGoBack}
        >
          <ChevronDownIcon className="text-content-primary dark:text-invertedPrimary80 rotate-90" />
        </Button>
        <SectionHeading>Team member notes</SectionHeading>
        <Counter value={notes?.length || 0}></Counter>
      </header>

      <div className="flex flex-col gap-6 pt-6 pb-6 w-full">
        {notes.map((note) => (
          <Note key={note.id} note={note} />
        ))}
      </div>
    </div>
  );
}
